import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const AddPersonIcon = () => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={53}
      height={52}
      viewBox="0 0 53 52"
      fill="none"
    >
      <g clipPath="url(#a)">
        <path
          d="M33 26a8.664 8.664 0 0 0 8.667-8.667A8.664 8.664 0 0 0 33 8.667a8.664 8.664 0 0 0-8.666 8.666A8.664 8.664 0 0 0 33 26m-19.5-4.333v-4.334a2.173 2.173 0 0 0-2.166-2.166 2.173 2.173 0 0 0-2.167 2.166v4.334H4.834a2.173 2.173 0 0 0-2.167 2.166c0 1.192.975 2.167 2.167 2.167h4.333v4.333c0 1.192.975 2.167 2.167 2.167a2.173 2.173 0 0 0 2.166-2.167V26h4.334A2.173 2.173 0 0 0 20 23.833a2.173 2.173 0 0 0-2.166-2.166zM33 30.333c-5.785 0-17.333 2.904-17.333 8.667v2.167c0 1.191.975 2.166 2.167 2.166h30.333a2.173 2.173 0 0 0 2.167-2.166V39c0-5.763-11.549-8.667-17.334-8.667"
          fill="#22C55D"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.5 0h52v52H.5z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { AddPersonIcon };
